import React, { Dispatch, SetStateAction } from "react";
import styles from "./dashboardSelect.module.css";
import { TOption } from "../../../services/types/utils.types";
import Select from "react-select";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import i18n from "../../../i18n";

const DashboardSelect: React.FC<{
  options: TOption[] | null;
  defaultOption: number | null;
  title: string;
  onChange: Dispatch<SetStateAction<number>>;
}> = ({ options, defaultOption, title, onChange }) => {
  const isRtl = i18n.language === "he";
  return (
    <div className={styles.comboBoxWrapper}>
      <p className={styles.comboBoxTitle}>{title}</p>

      <Select
        className={styles.comboBox}
        options={options || []}
        styles={customStyles(isRtl)}
        menuPlacement="auto"
        onChange={(t) => t && onChange(Number(t?.value))}
        placeholder={options?.length ? t("SELECT") : t('NO_REPORTS_AVAILABLE')}
        value={
          options?.find((op) => op.value === defaultOption?.toString()) ??
          undefined
        }
        isSearchable={true}
        noOptionsMessage={() => t("NO_RESULTS_FOUND")}
      />
    </div>
  );
};

export default DashboardSelect;

const customStyles = (isRtl: boolean) => ({
  control: (base: any) => ({
    ...base,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    border: "1px solid rgba(9, 143, 239, 1)",
    borderRadius: "6px",
    minHeight: "40px",
    fontSize: "16px",
    fontWeight: "600",
    boxShadow: "none",
    "&:hover": {
      borderColor: "rgba(9, 143, 239, 1)",
    },
    direction: isRtl ? "rtl" : "ltr",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "#0044c9",
    fontWeight: "600",
    fontSize: "16px",
    textAlign: isRtl ? "right" : "left",
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: "rgba(0, 67, 206, 1)",
    transform: isRtl ? "scaleX(-1)" : "none",
    "&:hover": {
      color: "rgba(0, 67, 206, 1)",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: "#fff",
    border: "1px solid rgba(9, 143, 239, 1)",
    borderRadius: "6px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    padding: "0",
    direction: isRtl ? "rtl" : "ltr",
    zIndex: 100,
  }),
  menuList: (base: any) => ({
    ...base,
    padding: "0",
  }),
  option: (base: any, { isFocused }: any) => ({
    ...base,
    color: "#00214e",
    fontWeight: "600",
    fontSize: "15px",
    padding: "10px",
    textAlign: isRtl ? "right" : "left",
    backgroundColor: isFocused ? "rgba(200, 230, 250, 1)" : "transparent", // Hover effect
    cursor: "pointer",
  }),
});

